module.exports = __webpack_public_path__ + "static/media/3.69261bfb.jpg";